import { render, staticRenderFns } from "./Abrangencia.vue?vue&type=template&id=455f53d2"
import script from "./Abrangencia.vue?vue&type=script&lang=js"
export * from "./Abrangencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports